import { ChangeEvent, ReactElement, useRef } from 'react';
import { Button } from 'components';
import { ButtonContainer } from '../../styles';
import { FilePlus1Icon } from '~/icons';
import { colors } from 'styles/colors';
import { useTranslation } from 'react-i18next';

interface FileButtonProps {
  onChangeFile: (file: File) => void;
  disabled?: boolean;
  label?: string
}

export function FileButton({
  disabled,
  onChangeFile,
  label,
}: Readonly<FileButtonProps>): ReactElement {
  const inputFileReference = useRef<HTMLInputElement>(null);
  const { t } = useTranslation();

  function onClickButton(): void {
    inputFileReference.current?.click();
  }

  function onFileChange(event: ChangeEvent<HTMLInputElement>): void {
    const file = event.target.files?.[0];
    if (file) {
      onChangeFile(file);
    }
  }

  return (
    <>
      <Button
        variant="primary-filled"
        type="button"
        style={{ width: '150px', height: '28px' }}
        onClick={onClickButton}
        disabled={disabled}
      >
        <ButtonContainer>
          <FilePlus1Icon color={colors.icon['white-0']} size={14} />
          <span>{label ?? t('selecionarArquivo')}</span>
        </ButtonContainer>
      </Button>
      <input
        accept=".xlsx,application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
        type="file"
        ref={inputFileReference}
        onChange={onFileChange}
        hidden
      />
    </>
  );
}
